import { Channel } from '@weave/schema-gen-ts/dist/schemas/comm-preference/shared/v1/enums.pb';
import { useGetPreference } from '@frontend/api-comm-preference';
import { getUser } from '@frontend/auth-helpers';
import { useAppScopeStore } from '@frontend/scope';
import { theme } from '@frontend/theme';
import { Accordion } from '@frontend/design-system';
import { FaxEmailLocationAccordion } from './fax-email-location-accordion';
import { FaxEmailTable } from './fax-email-table';

export const FaxEmailUpdates = () => {
  const { selectedLocationIds, getLocationName, isSingleTypeScope } = useAppScopeStore();

  const user = getUser();

  const { data: emailPreferences, refetch } = useGetPreference(
    {
      userChannelAddress: user?.username,
      channel: Channel.CHANNEL_WEAVE_EMAIL_UPDATE,
      locationId: selectedLocationIds[0],
    },
    {},
    !!isSingleTypeScope
  );

  return (
    <>
      {isSingleTypeScope ? (
        <FaxEmailTable locationId={selectedLocationIds[0]} emailPreferences={emailPreferences} refetch={refetch} />
      ) : (
        <Accordion
          variant='location'
          css={{
            marginTop: theme.spacing(2),
            width: 800,
            overflowX: 'scroll',
          }}
        >
          {selectedLocationIds.map((locationId) => (
            <FaxEmailLocationAccordion
              key={locationId}
              locationId={locationId}
              locationName={getLocationName(locationId)}
            />
          ))}
        </Accordion>
      )}
    </>
  );
};
